import { config } from "../../../../config";
import { uuidv4 } from "../../../../utils/uuid";
import yup, { yupUUID } from "../../../../utils/yup";

const chatButtonSchema = yup.object({
  id: yupUUID.default(() => uuidv4()),
  text: yup
    .string()
    .required("Enter some text for the button")
    .default("")
    .max(config.slack.maxButtonTextLength, "Button text too long."),
  url: yup
    .string()
    .url_or_merge_tag("Enter a link in a valid format (including https://)")
    .required("Enter a link for the button")
    .default(""),
});
export const chatButtonFormSchema = yup.object({
  buttons: yup.array(chatButtonSchema).default([]),
});

export type ChatButtonForm = yup.InferType<typeof chatButtonFormSchema>;
